import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import PageMeta from "@/components/base/PageMeta";

const siteUrl = import.meta.env.VITE_PUBLIC_SITE_URL || "https://hackerslodge.com";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center px-4">
      <PageMeta
        title="404 — Page Not Found"
        description="The page you are looking for does not exist or has been moved. Return to Hackers Lodge to browse hackers, projects, and cybersecurity services."
        canonicalUrl={`${siteUrl}/404`}
        noindex={true}
      />
      <div className="text-center max-w-md">
        <h1 className="text-8xl md:text-9xl font-black text-gray-50/10 select-none mb-4">
          404
        </h1>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-200 mb-2">
          Page Not Found
        </h2>
        <p className="text-sm text-gray-500 mb-2 leading-relaxed">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        {location.pathname && location.pathname !== "/" && (
          <p className="text-xs text-gray-600 font-mono mb-6">{location.pathname}</p>
        )}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-[#5cb85c] hover:bg-[#4cae4c] text-white text-sm font-semibold px-6 py-2.5 rounded transition-all whitespace-nowrap"
          >
            <i className="fas fa-home mr-1" /> Back to Home
          </Link>
          <Link
            to="/hackers"
            className="inline-flex items-center gap-2 border border-gray-600 hover:bg-[#161b22] text-gray-300 text-sm font-semibold px-6 py-2.5 rounded transition-all whitespace-nowrap"
          >
            <i className="fas fa-user-secret mr-1" /> Browse Hackers
          </Link>
        </div>
      </div>
    </div>
  );
}